import { render } from "./tvChart.vue?vue&type=template&id=5b417e01"
import script from "./tvChart.vue?vue&type=script&lang=js"
export * from "./tvChart.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/tvChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b417e01"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b417e01', __exports__)) {
    api.reload('5b417e01', __exports__)
  }
  
  module.hot.accept("./tvChart.vue?vue&type=template&id=5b417e01", () => {
    api.rerender('5b417e01', render)
  })

}


export default __exports__